<template>
	<!--
    	作者：YX
    	时间：2017-10-10
    	描述：分配可管理菜单
    -->
    <div class="bg_add">
		<div class="changead">
			<div class="changeadinput">
				<ul>
					<li v-for="(list,index) in lists" :key="index">
						<div class="checkbox" :class="{checkboxtrue:list.status == 1}"
							@click="changebox(list,index)"
							>
						</div>
						<span>{{list.name}}</span>
					</li>
					<el-button type="primary" @click="sumbitCode()">提交</el-button>
					<el-button @click="pageback">取消</el-button>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapStatus} from 'Vuex'
	export default{
		name:'add-menu',
		props:['addmenu'],
		data(){
			return{
				lists:[],
				menuids:[
					{
						id:'',
						menustatus:0,
					}
				],
				menunum:0,
				changetrue:false,
			}
		},
		created:function(){
			this.postmenudata()
		},
		methods:{
			changebox(list,index){
				if(list.status == 0){
					return	list.status = 1
				}else{
					return	list.status = 0
				}
			},
			pageback(){
				this.$emit('changeMenuFalse')
			},
			postmenudata(){
				this.$jssdk.admin.getPowerList({admin_id:this.addmenu.admin_id},(data)=>{
					this.lists = data.list
					this.menuids = this.lists
					
				})
			},
			sumbitCode(){
				this.$jssdk.admin.editPowerList({admin_id:this.addmenu.admin_id,power_id:this.menuids},(data)=>{
					console.log(data)
					this.$message.success('修改菜单成功')
					this.pageback()
					return
				}),(err) =>{
					this.$message.warning(err.msg)
					return
				}
			},
		},
	}
</script>

<style scoped="scoped">
	.bg_add{
		background-color: rgba(0,0,0,.7);
		width: 100%;
		height: 965px;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 6;
	}
	.changead{
		background-color: white;
		width:450px;
		position: absolute;
		left: 740px;
		top: 340px;
		color: white;
		z-index: 3;
		overflow: hidden;
		padding: 15px;
		border-radius: 15px;
		border:1px solid #ccc;
		box-shadow: 2px 2px 2px #000;
	}
	.changeadinput{
		width: 370px;
		color: red;
		margin: 0 auto;
		text-align: center;
		padding: 20px 0;
	}
	.changeadinput ul{
		list-style:none;
		margin: 0;
		padding: 0;
		overflow: hidden;
	}
	.changeadinput ul li{
		border-bottom:1px solid #ccc;
		height: 30px;
		text-align: left;
		margin-top: 10px;
		margin-bottom: 20px;
	}
	.changeadinput ul li span{
		color: black;
		margin-left: 25px;
	}
	.checkbox{
		background-image: url(../assets/check.png);
		background-repeat: no-repeat;
		background-size: 100%;
		width: 20px;
		height: 20px;
		display: inline-block;
		float: left;
	}
	.checkboxtrue{
		background-image:url(../assets/check_true.png) !important;
	}
	@media only screen and (max-width:1400px ) {
		.changead{
			background-color: white;
			width:450px;
			position: absolute;
			left: 440px;
			top: 40px;
			color: white;
			z-index: 3;
			overflow: hidden;
			padding: 15px;
			border-radius: 15px;
			border:1px solid #ccc;
			box-shadow: 2px 2px 2px #000;
		}
	}
</style>


// WEBPACK FOOTER //
// addMenu.vue?edb415c4